module.exports = __webpack_public_path__ + "media/images/clients/exit_green-93d678db67b723777cd49a923c02a3c7.png";